import React from "react";
import { connect } from "react-redux";
import { Row, Col, Label, Input, FormGroup } from "reactstrap";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { content } from "../../../../models/content";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import Select from "react-select";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";
import { IconButton } from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import JirangoDatePicker from "../../../../../global/JirangoDatepicker";


const targetTypes = [
  { value: "self", label: <SystemLabel name="SameWindow" /> },
  { value: "blank", label: <SystemLabel name="NewWindow" /> },
];
class ButtonSettings extends React.Component {
  handleSoftUpdate = (element) => {
    const { dispatch, enviroment, page } = this.props;
    if (enviroment === sourceTypes.FORM)
      dispatch(formActions.updateFormElement(element));
    if (enviroment === sourceTypes.PAGE)
      dispatch(pageActions.updatePageElement(element, null, page));
    if (enviroment === sourceTypes.TEMPLATE) {
      const template = deepClone(this.props.template);
      const newTemplate = templateHelper.handleElementUpdates(
        element,
        template
      );
      dispatch(templateActions.softUpdate(newTemplate));
    }
  };
  setAttribute = (attr, path) => {
    const { selectedElement } = this.props;
    const names = path.split(".");
    let element = deepClone(selectedElement);

    if (path === "data.style") {
      const defSettings = content.find((el) => {
        return el.settings.type === element.data.type;
      });
      element.data.style = deepClone(defSettings.settings.style);
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = attr;
    } else {
      element[names[0]][names[1]] = attr;
    }
    this.handleSoftUpdate(element);
  };
  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray,
    });
  };
  handleChange = (e, val, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = null;
    if (val && val.hex !== undefined) {
      const { r, g, b, a } = val.rgb;
      value = `rgba(${r},${g},${b},${a})`;
    } else if (path == "data.startDate" || path == "data.endDate") {
      console.log("datestuff")
      if ((path == "data.endDate" || path == "data.startDate") && val == null){
        value = null;
      }
      else if (path == "data.endDate" && element.data.startDate) {
        if (+new Date(val) <= element.data.startDate) return;
      }
      value = +new Date(val);
    } else if (val) value = val;
    else {
      if (!e) value = val;
      else value = e.target.value;
    }
    if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.handleSoftUpdate(element);
  };
  handleSpaceOnChange = (e, path, dir) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    const spaceValue = element[names[0]][names[1]];
    let value = e.target.value;
    let splitted = spaceValue.toString().split(" ");
    if (splitted.length > 1) {
      splitted[dir] = value + "px";
      splitted = splitted.join(" ");
      element[names[0]][names[1]] = splitted;
    } else {
      let newString = `${splitted[0]}px ${splitted[0]}px ${splitted[0]}px ${splitted[0]}px`;
      newString = newString.split(" ");
      newString[dir] = value + "px";

      element[names[0]][names[1]] = newString.join(" ");
    }
    this.handleSoftUpdate(element);
  };
  convertSpaceValue = (value, index) => {
    let splitted = value.toString().split(" ");
    if (splitted.length > 1) {
      return parseInt(splitted[index]);
    } else {
      return parseInt(splitted[0]);
    }
  };

  render() {
    const { selectedElement } = this.props;
    return (
      <div>
        <ListExpansion
          footer={false}
          icon="fa fa-image"
          description="ButtonSettings"
          defaultExpanded={true}
        >
          <AlignmentButtonGroup
            onChange={this.handleChange}
            alignment={selectedElement.data.alignment}
            path="data.alignment"
            type={["left", "center", "right"]}
          />
          <hr />
          {selectedElement.data.padding !== undefined ? (
            <React.Fragment>
              <Row>
                <Col className="list-setting-item-title">
                  <Label>
                    <SystemLabel name="Padding" />
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col
                  className="list-setting-item-title"
                  style={{ display: "inline-flex" }}
                >
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={(e) =>
                        this.handleSpaceOnChange(e, `data.padding`, 0)
                      }
                      value={this.convertSpaceValue(
                        selectedElement.data.padding,
                        0
                      )}
                    />
                    <em>
                      <p style={{ textAlign: "center" }} className="text-muted">
                        <SystemLabel name="Top" />
                      </p>
                    </em>
                  </div>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={(e) =>
                        this.handleSpaceOnChange(e, `data.padding`, 1)
                      }
                      value={this.convertSpaceValue(
                        selectedElement.data.padding,
                        1
                      )}
                    />
                    <em>
                      <p style={{ textAlign: "center" }} className="text-muted">
                        <SystemLabel name="Right" />
                      </p>
                    </em>
                  </div>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={(e) =>
                        this.handleSpaceOnChange(e, `data.padding`, 2)
                      }
                      value={this.convertSpaceValue(
                        selectedElement.data.padding,
                        2
                      )}
                    />
                    <em>
                      <p style={{ textAlign: "center" }} className="text-muted">
                        <SystemLabel name="Bottom" />
                      </p>
                    </em>
                  </div>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={(e) =>
                        this.handleSpaceOnChange(e, `data.padding`, 3)
                      }
                      value={this.convertSpaceValue(
                        selectedElement.data.padding,
                        3
                      )}
                    />
                    <em>
                      <p style={{ textAlign: "center" }} className="text-muted">
                        <SystemLabel name="Left" />
                      </p>
                    </em>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          ) : null}
          {/*      <EditorSlider
            value={selectedElement.data.style.width !== undefined &&
              selectedElement.data.style.width !== "unset"
              ? parseFloat(selectedElement.data.style.width)
              : 0}
            defaultValue={0}
            unitChange={() => null}
            onChange={this.handleChange}
            units={["px"]}
            activeUnit={'px'}
            attachUnit={true}
            steps={1}
            max={500}
            min={1}
            path={'data.style.width'}
            label="ButtonWidth"
          />
          <hr />
          <EditorSlider
            value={selectedElement.data.style.height !== undefined &&
              selectedElement.data.style.height !== "unset"
              ? parseFloat(selectedElement.data.style.height)
              : 0}
            defaultValue={0}
            unitChange={() => null}
            onChange={this.handleChange}
            units={["px"]}
            activeUnit={'px'}
            attachUnit={true}
            steps={1}
            max={500}
            min={1}
            path={'data.style.height'}
            label="ButtonHeight"
          /> */}
          <hr />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="ActionLink" />
              </Label>
            </Col>
          </Row>
          <UrlMultiInput
            margin={false}
            externalSourceOnly={true}
            linkHelper={true}
            target={selectedElement.data.target}
            onChange={this.handleChange}
            path={"data.actionLink"}
            url={selectedElement.data.actionLink}
          />
          <br />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="TargetType" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <Select
                classNamePrefix="jirango-select"
                className="jirango-select"
                options={targetTypes.map((t) => {
                  return { value: t.value, label: t.label };
                })}
                value={targetTypes.find((t) => {
                  return t.value === selectedElement.data.target;
                })}
                onChange={(selectedOption) =>
                  this.handleChange(null, selectedOption.value, "data.target")
                }
              />
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="DisplayTimer" />
              </Label>
            </Col>
            <Col
              className="list-setting-item-input"
              style={{ textAlign: "right" }}
            >
              <JirangoSwitch
                onChange={() =>
                  this.handleChange(
                    null,
                    !selectedElement.data.timer,
                    "data.timer"
                  )
                }
                isChecked={selectedElement.data.timer}
              />
            </Col>
          </Row>
          <br />
          {selectedElement.data.timer == true ? (
            <React.Fragment>
              <Row>
                <Col className="list-setting-item-title col-9">
                  <FormGroup style={{ width: "100%" }}>
                    <Label htmlFor="form-name-label">
                      {" "}
                      <SystemLabel name="EnableAfter" />
                    </Label>
                    <JirangoDatePicker
                      handleChange={(value) =>
                        this.handleChange(null, value, "data.startDate")
                      }
                      value={selectedElement.data.startDate}
                    />

                   {/*  <Input
                      type="datetime-local"
                      value={
                        selectedElement.data.startDate
                          ? new Date(
                              selectedElement.data.startDate
                            ).toLocaleString()
                          : ""
                      }
                      onChange={(e) => {
                        console.log(e.target.value);
                        console.log(
                          new Date(e.target.value).toLocaleTimeString()
                        );

                        this.handleChange(
                          null,
                          e.target.value,
                          "data.startDate"
                        );
                      }}
                    /> */}
                  </FormGroup>
                </Col>
                <Col className="col-2" style={{ paddingTop: 20 }}>
                  <IconButton
                    onClick={() =>
                      this.handleChange(null, null, "data.startDate")
                    }
                  >
                    <CloseIcon style={{ fontSize: 18 }} />
                  </IconButton>
                </Col>
              </Row>
              <Row>
                <Col className="list-setting-item-title col-9">
                  <FormGroup style={{ width: "100%" }}>
                    <Label htmlFor="form-name-label">
                      {" "}
                      <SystemLabel name="DisableAfter" />
                    </Label>
                    <JirangoDatePicker
                      handleChange={(value) =>
                        this.handleChange(null, value, "data.endDate")
                      }
                      value={selectedElement.data.endDate}
                    />
                  </FormGroup>
                </Col>
                <Col className="col-2" style={{ paddingTop: 20 }}>
                  <IconButton
                    onClick={() =>
                      this.handleChange(null, null, "data.endDate")
                    }
                  >
                    <CloseIcon style={{ fontSize: 18 }} />
                  </IconButton>
                </Col>
              </Row>
            </React.Fragment>
          ) : null}
        </ListExpansion>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let selectedElement = null;
  if (enviroment === sourceTypes.FORM)
    selectedElement = state.form.selectedElement;
  if (enviroment === sourceTypes.PAGE)
    selectedElement = state.page.selectedElement;
  if (enviroment === sourceTypes.TEMPLATE)
    selectedElement = state.template.selectedElement;
  return {
    enviroment: enviroment,
    template: state.template.template,
    form: state.form,
    page: state.page,
    selectedElement: selectedElement,
  };
}
export default connect(mapStateToProps)(ButtonSettings);
